import * as React from 'react';
import favicon32 from '../../../../assets/favicons/Favicon-1.png';
import favicon180 from '../../../../assets/favicons/Favicon-2.png';

const MetaTags = () => {
  return (
    <>
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black" />
      <meta
        name="viewport"
        content="width = device-width,maximum-scale=1,initial-scale = 1,minimum-scale=1.0, user-scalable=no,shrink-to-fit=no"
      />
      <meta name="keywords" content="Smart Apps" />
      <meta name="description" content="Smart Apps" />
      <meta name="author" content="smartis" />
      <link rel="manifest" href="manifest.json" />
      <link rel="icon" type="image/png" sizes="32x32" href={favicon32} />
      <link rel="icon" type="image/svg" sizes="192x192" href={favicon180} />
      <link
        rel="apple-touch-icon"
        type="image/png"
        sizes="180x180"
        href={favicon180}
      />
    </>
  );
  return tags;
};

export default MetaTags;
